import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

// layouts
import { MainLayout } from 'layouts';

// components
import { MenuSections } from 'components/all';
import { Loading } from 'components/common';
import Text from 'components/ui/Text';

// utils
import { api } from 'utils';

// hooks
import useKioskControl from 'hooks/useKioskControl';

const menuSections = [
  { label: '센터 이미지 설정', to: '/all/settings/center/image' },
  { label: '센터 정보 설정', to: '/all/settings/center/info' },
  { label: '대표자 정보 설정', to: '/all/settings/center/ceo' },
];

const CenterSettings = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState({});

  const { partner, partnerBranch, seqPartner, seqPartnerBranch } = location.state;

  const {
    kiosks,
    doorMessage,
    setDoorMessage,
    keepOpenLoading,
    doorLoading,
    getKioskList,
    handleOpenDoor,
    handleToggleAlwaysOpen,
  } = useKioskControl(seqPartner, seqPartnerBranch);

  const getCenterInfo = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`partners/${seqPartner}/${seqPartnerBranch || 0}`);
      setInfo(data);
    } catch (error) {
      console.error('센터 정보 불러오기 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCenterInfo();
    getKioskList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor='white'
      headerProps={{ withBackButton: true, centerTitle: '센터 정보 설정' }}>
      {(loading || doorLoading) && <Loading />}
      <Wrapper>
        <CenterBox>
          <Text display='block' color='primary100' fontSize='14px' fontWeight='500' lineHeight='18px'>
            {partner} {partnerBranch}
          </Text>
        </CenterBox>

        <MenuSections
          page='setting'
          sections={kiosks.length > 0 ? [...menuSections, { label: '출입문 제어', action: 'openDoor' }] : menuSections}
          state={location.state}
          info={info}
          onDoorOpen={handleOpenDoor}
          onToggleAlwaysOpen={handleToggleAlwaysOpen}
          onRefresh={getKioskList}
          keepOpenLoading={keepOpenLoading}
          setDoorMessage={setDoorMessage}
          kiosks={kiosks.map((kiosk, index) => {
            const kioskName = kiosk.kioskName || `kiosk-${index}`;
            return {
              ...kiosk,
              isKeepOpen: doorMessage[kioskName]?.isKeepOpen ?? kiosk.isKeepOpen,
              alwaysOpen: doorMessage[kioskName]?.alwaysOpen ?? kiosk.alwaysOpen,
              statusMessage: doorMessage[kioskName]?.statusMessage || null,
              statusType: doorMessage[kioskName]?.statusType || null,
            };
          })}
        />
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 0 20px;
`;

const CenterBox = styled.div`
  background: #eef5ff;
  border-radius: 6px;
  margin: 12px 0;
  padding: 12px 0;
  text-align: center;
`;

export default CenterSettings;
